import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import {
  AddShoppingCart,
  ReplayCircleFilled,
  SvgIconComponent,
} from "@mui/icons-material";
import {
  Box,
  IconProps,
  SvgIconProps,
  SxProps,
  Tooltip,
  TooltipProps,
} from "@mui/material";
import AppIconsCart from "./AppIconsCart";
import CircleButton from "../AppButtons/CircleButton";
import AppIconsCartFilled from "./AppIconsCartFilled";

export type ReplaceIconProps = {
  title?: string;
  sx?: SxProps | undefined;
  propsToolTipCSS?: React.CSSProperties | undefined;
  propsToolTip?: TooltipProps;
  propsIcon?: SvgIconProps | undefined;
};

const BasketIcon = function (props: ReplaceIconProps) {
  const newPropsIcon = props.propsIcon || { fontSize: "small" };

  return (
    <Box sx={props.sx}>
      <Tooltip
        {...props.propsToolTip}
        sx={props.propsToolTipCSS}
        title={props.title}
      >
        <AppIconsCartFilled {...newPropsIcon} />
      </Tooltip>
    </Box>
  );
};
export default BasketIcon;
